import * as Yup from "yup";

import { passwordMinLength } from "./constants.js";

const email = Yup
	.string()
	.email("Invalid e-mail address")
	.required("E-mail address is required");

const username = Yup
	.string()
	.required("Το Όνομα χρήστη είναι υποχρεωτικό");

const fullName = Yup
	.string()
	.required("Το Ονοματεπώνυμο είναι υποχρεωτικό");

const emailOrUsername = Yup
	.string()
	.required("Email or Username is required");

const agree = Yup.boolean().oneOf([true], "You have to agree");

const password = Yup
	.string()
	.min(passwordMinLength, `Ο Κωδικός θα πρέπει να περιέχει τουλάχιστον ${passwordMinLength} χαρακτήρες`)
	.required("Ο Κωδικός είναι υποχρεωτικός");

const confirmPassword = Yup
	.string()
	.min(passwordMinLength, `Password should contain at least ${passwordMinLength} characters`)
	.required("Password is required")
	.oneOf([Yup.ref("password")], "Passwords must match");

const schemas = {
	authenticationSchema: Yup.object({ emailOrUsername }),
	forgotPasswordSchema: Yup.object({ username }),
	resetPasswordSchema: Yup.object({ password, confirmPassword }),
	signUpSchema: Yup.object({ username, password, fullName }),
	exampleSchema: Yup.object({ username, password, agree }),
	inviteUserSchema: Yup.object({ email }),
};

export default schemas;
